import { eventHub, EVENT_NAMES } from './eventService';
import { hasUserTrackingConsentGiven, initGoogleAnalytics, TRACKING_COOKIE_NAME } from './trackingService';

const FDA_COOKIE_NAME = 'fda-consent';
const COOKIE_LIFETIME = 7776000;
const FdACookieRegExp = new RegExp(`${FDA_COOKIE_NAME}=(?<value>[-a-z0-9]+);?`);

export function promptConsent() {
    eventHub.$emit(EVENT_NAMES.MODAL_OPEN, {
        modalId: 'consent-manager',
        disableBodyScroll: true,
        dontCorrectOffset: true,
        needsToBeTopmost: true
    });
}

export function hasUserFdAConsentGiven() {
    const match = FdACookieRegExp.exec(document.cookie);

    if (!match) {
        return null;
    }

    return JSON.parse(match.groups.value);
}

export function setFdACookie(value) {
    document.cookie = `${FDA_COOKIE_NAME}=${value}; Path=/; max-age=${COOKIE_LIFETIME}; samesite=strict;`;

    // there is only something to do on homepage
    if (window.currentPage == "homepage") {
        if (value) {
            initFdA()
        } else {
            disableFdA();
        }
    }
}

export function initializeConsent(isCockpitPreview) {
    if (isCockpitPreview) {
        return;
    }

    // tracking consent is also necessary
    const weMayFdA = hasUserFdAConsentGiven();
    const weMayTrack = hasUserTrackingConsentGiven();

    if (weMayFdA === null && !window.hasChatId || weMayTrack === null) {
        document.addEventListener(
            'DOMContentLoaded',
            promptConsent,
            { once: true }
        );
    } else {
        // FdA is only on homepage available
        if (weMayFdA && window.currentPage == "homepage" && !window.hasChatId) {
            initFdA();
        }
        if (weMayTrack) {
            initGoogleAnalytics();
        }
    }
}

function initFdA() {

    window.__lc = window.__lc || {};
    window.__lc.license = 16897281;
    window.__lc.integration_name = "manual_channels";
    window.__lc.product_name = "livechat";
    (function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
}

function disableFdA() {
    location.reload();
}

export function deleteCookies(){
    deleteCookie(FDA_COOKIE_NAME);
    deleteCookie(TRACKING_COOKIE_NAME);
    location.reload();
}

function deleteCookie(cookieName) {
  document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}